import { DataFormModal } from "..";
import { useDataTableContext } from "./hooks/useDataTableContext";

const DataTableModal = () => {
	const {
		isModalOpen,
		setIsModalOpen,
		modalAction,
		initialModalData,
		dataTableEditorSettings,
		refreshTableData,
	} = useDataTableContext();

	const editorSetting =
		dataTableEditorSettings?.actions.find(
			(actionSetting) => actionSetting.action === modalAction
		) || {};

	return (
		<DataFormModal
			isModalOpen={isModalOpen}
			setIsModalOpen={setIsModalOpen}
			editorSetting={editorSetting}
			initialModalData={initialModalData}
			refreshData={refreshTableData}
		/>
	);
};

export { DataTableModal };
